import e from "@dialpad/dialtone-tokens/layered/themes/tokens-coral-reef-colors.css?inline";
//#region themes/coral-reef.js
var t = {
	brand: {
		css: e,
		name: "coral-reef"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
